import React, { useState } from 'react';
import { Button,Balloon } from '@alifd/next';
import { useHistory } from "react-router-dom";
import LzDialog from '@/components/common/LzDialog';
import styles from './index.module.scss';
import ProductLineDialog from '../ProductLineDialog';
import TopTitle from '@/components/UI/TopTitle';
import goodsLineTips from '@/assets/images/CrossCategory/goods-line-tips.png'

const WIDTH = window.screen.width; //获取屏幕宽度
/**
 * @param productId 选中的商品分组id
 * @param changeProductId 修改商品分组id方法
 * @param productList 选中的商品分组数组
 * @param changeProductList 修改商品分组数组方法
 * @param checkType 1新建2复制3查看
 */
 const ChooseProductLine = ({productId, changeProductId, productList, changeProductList, checkType,setSkuId,params,setParams,setForLine,setForSku,setRepeatNum}) => {
  let history = useHistory();
  // 商品分组选择弹窗
  const [productLineDialog, setProductLineDialog] = useState(false);
  // 是否展开更多
  const [showMore, setShowMore] = useState('none');

  const [repeatObj, setRepeatObj] = useState({
    repArr:[],
    suc:0,
    rep:0
  })

  //被选的商品分组
  const [selectLine, setSelectLine] = useState([])
  return (
    <div className={styles['select-big-box']}>
      <TopTitle title='商品分组选择'/>
      <div>
        <div className={styles.baseInfoContent}>
          <div style={{display: "flex",alignItems: "center"}}>
            <Button type="primary" disabled={+checkType === 3} className={styles.finishButton} onClick={() => setProductLineDialog(true)}>选择商品分组</Button>
            <span>已选<span style={{color: "#FF3333",padding:"0px 5px"}}>{productList.length}</span>个</span>
            <Button text type="primary" disabled={+checkType === 3} onClick={()=>{history.push('/goodsManage/group')}}  style={{marginLeft:"20px"}}>去创建商品分组</Button>
          </div>
          <div className={styles['select-product-line-tips']}>
            <div>注：1.请选择需要进行复购营销的商品，模型会基于所选商品分组进行复购人群的运算和拉取。</div>
            <div style={{marginLeft:"24px",marginTop:"5px"}}>2.请先去商品管理-商品组管理进行商品分组的创建。</div>
          </div>
          <div>
            {
              selectLine.length > 0 && +repeatObj.rep === 0 ?
              <div>
                包含有效SKU<span className={styles['include-sku-num']}>{repeatObj.suc}</span>个
              </div>
              :
              selectLine.length > 0 && +repeatObj.rep !== 0 ?
              <div className={styles['sku-tips-box']}>
                包含有效SKU<span className={styles.red}>{repeatObj.suc}</span>个，重复SKU<span className={styles.red}>{repeatObj.rep/2}</span>个，重复SKU的复购周期，会以录入复购周期中最小周期计算。
                <Balloon
                  align="t"
                  shouldUpdatePosition
                  closable={false}
                  trigger={<span className={styles['sku-tips-btn']}>重复SKU详情</span>}
                >
                  <div>{repeatObj.repArr.join(',')}</div>
                </Balloon>
              </div>
              :
              ''
            }
          </div>
          <div style={{marginTop:'15px'}}>
            <div style={{display: "grid",gridTemplateColumns: "repeat(auto-fill, 240px)"}}>
              {
                productList.map((item,index) =>
                  <div className={styles['show-goods-line-box']} key={item.id}  style={{display:(index+1) * 240 >(window.innerWidth-432) ? showMore: ''}}>
                    <div className={styles['goods-line-name-box']} title={item.productLineName} >
                      <img src={goodsLineTips} className={styles['goods-line-tips-icon']}/><div className={styles['over-text']}>{item.productLineName}</div>
                    </div>
                    <div className={styles['goods-line-info-box']}>
                      <div className={styles['show-goods-line-info']}>
                        <div>商品分组包含SKU数</div>
                        <span className={`${styles['goods-line-num-style']} ${styles['over-text']}`}>{item.skuNumber}</span>
                      </div>
                      <div className={styles['show-goods-line-info1']}>
                        <div>品线类型/级别</div>
                        <span className={`${styles['goods-line-num-style']} ${styles['over-text']}`} title={`${item.productLineType} ${item.productLineLv || 0}级`}>{`${item.productLineType} ${item.productLineLv || 0}级`}</span>
                      </div>
                    </div>
                  </div>
                  )
              }
            </div>
          </div>
          {
            <div className={styles['show-more-btn']} style={{display:productList.length * 240 > (window.innerWidth-432) ? '' : 'none'}}>
              <Button text type="primary" className={styles.mb10} onClick={()=>{setShowMore(showMore===''?'none':'')}}>{showMore ? "展开更多" : "收起更多"} <span className={`iconfont ${showMore ?'icon-iconw-12':'icon-iconw-13'} ${styles['icon-style1']}`}/></Button>
            </div>
          }
        </div>
      </div>
      <LzDialog shouldUpdatePosition isFullScreen visible={productLineDialog} onClose={() => { setProductLineDialog(false) }}
        footer={false}
        title="商品分组选择"
        style={{ width: 1060 }}>
          <ProductLineDialog params={params} setRepeatNum={(v)=>{setRepeatNum(v)}} setForLine={(v,id,from)=>{setForLine(v,id,from)}} setForSku={(v,id,from)=>{setForSku(v,id,from)}} setParams={(v,id)=>{setParams(v,id)}} repeatObj={(v)=>{setRepeatObj(v)}} fatherProductId={productId} changeProductId={v => {changeProductId(v),setSelectLine(v)}} fatherProductList={productList} changeProductList={v => changeProductList(v)} closeDialog={() => setProductLineDialog(false)}
          //  setId={(v)=>{setSkuId(v)}}
          />
      </LzDialog>
    </div>
  )
}

export default ChooseProductLine;
